import { Moon, Sun } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { toggleTheme } from '../theme/theme'
import { contentFor } from '../transport/content'
import { pagePath } from '../transport/routes'
import type { Locale } from '../transport/types'
import { Logo } from './Logo'

export function Header({ locale }: { locale: Locale }) {
  const content = contentFor(locale)
  const homePath = pagePath(locale, 'home')
  const languagePath = pagePath(locale === 'ar' ? 'en' : 'ar', 'home')
  const themeLabel = locale === 'ar' ? 'تبديل المظهر' : 'Toggle theme'

  return (
    <header className="site-header map-header">
      <div className="header-inner map-header__inner">
        <Logo locale={locale} homePath={homePath} />

        <div className="map-header__actions">
          <button
            type="button"
            className="map-header__theme"
            aria-label={themeLabel}
            title={themeLabel}
            onClick={toggleTheme}
          >
            <Sun className="theme-icon theme-icon--sun" aria-hidden="true" />
            <Moon className="theme-icon theme-icon--moon" aria-hidden="true" />
          </button>

          <NavLink className="map-header__language" to={languagePath}>
            {content.languageLabel}
          </NavLink>
        </div>
      </div>
    </header>
  )
}
